export const getArray = <T = any>(input: T|T[]): T[] => {
    return Array.isArray(input) ? input : [input];
};
